import { Tab } from "bootstrap";
import React, { useEffect } from "react";
import Slider from "react-slick";
import { Col, Container, Row, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const index = (props) => {
  const brand = [
    { image: "./assets/images/dell.png" },
    { image: "./assets/images/GIT.png" },
    { image: "./assets/images/ltim.png" },
    { image: "./assets/images/nyp.png" },
    { image: "./assets/images/ncs_logo.png" },
    { image: "./assets/images/olay.png" },
  ];

  var Brand = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const patner_slider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className="growWithUsPage">
      <section className="growWithUsBanner">
        <div className="container">
          <div className="growBannerRow">
            <div className="growBannerCaption">
              <h1>
                Empower Your Community with <br />
                <span>Smart Mentoring Technology</span>
              </h1>
              <p>
                vLookUp is an AI-powered mentoring platform that makes
                mentorship effortless, scalable, and impactful. Designed for
                organizations, educational institutions, and professional
                networks, our platform connects employees, students, and
                professionals through structured, goal-driven mentorship that
                accelerates growth and development. With vLookUp, you can
                facilitate real-time, global 1:1 mentoring engagements – without
                the administrative burden.
              </p>
              <div className="bannerAction">
                <div className="text-black mb-3 mb-md-4">
                  See vLookUp in action?
                </div>
                <Link to=""  className="btn">
             
                  Book a Demo Today
                  <span className="ml-2 verticle-middle mt-1"><img src="assets/images/whiteArrow.svg" /></span>
                </Link>
              </div>
            </div>

            <figure>
              <img src="./assets/images/growbanner.png" alt="growbanner" />
            </figure>
          </div>
        </div>
      </section>

      <section className="Powerful_Ways_Section">
        <div className="container">
          <div className="titleHeadTop mb-3 mb-md-5 text-center">
            <h2>
              Two Powerful Ways to Build Your <br />
              <span>Mentoring Program</span>
            </h2>
          </div>

          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <div className="Powerful_Ways">
                <figure>
                  <img
                    src="./assets/images/vlookUpSaas.svg"
                    alt="vlookUpSaas"
                  />
                </figure>
                <figcaption>
                  <h4>vLookUp SaaS</h4>
                  <p>
                    A plug-and-play mentoring platform, fully configurable to
                    suit your organization's needs.
                  </p>
                </figcaption>
              </div>
            </Col>

            <Col md={6} className="mb-4 mb-md-0">
              <div className="Powerful_Ways">
                <figure>
                  <img
                    src="./assets/images/PartnershipsIcon.svg"
                    alt="PartnershipsIcon"
                  />
                </figure>
                <figcaption>
                  <h4>vLookUp Partnerships</h4>
                  <p>
                    Curated mentoring programs designed to create real,
                    measurable impact.
                  </p>
                </figcaption>
              </div>
            </Col>
          </Row>

          <div className="EmpowerYourTeam">
            <p>
              Empower your team, foster growth, and unlock potential with
              vLookUp today.{" "}
            </p>
            <a href="#" className="btn">
              Connect with us.
            </a>
          </div>
        </div>
      </section>

      <section className="tabs_Wrapper_Section">
        <div className="container">
          <div className="tabs_Wrapper">
            <Tabs
              defaultActiveKey="vLookUp_SaaS"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              {/* vLookUp SaaS Tabs */}
              <Tab eventKey="vLookUp_SaaS" title="vLookUp SaaS ">
                <div className="V_Saas_Smart">
                  <h5>
                    The Smart, Scalable Mentoring Solution for Educational
                    Institutions & Organizations
                  </h5>
                  <p>
                    Take mentorship to the next level with vLookUp SaaS – a
                    powerful, easy-to-use platform designed to scale with your
                    needs. Whether you’re focusing on leadership development,
                    alumni engagement, or career advancement, vLookUp provides a
                    seamless experience to connect and empower your community.
                  </p>
                </div>

                <div className="coreOfSolution">
                  <h3 className="block_Section">
                    What is at the Core of Our Solution
                  </h3>
                  <div className="coreOfSolution_White_Wrapper mb-3 mb-md-5">
                    <Row className="">
                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/ai_Icon.svg"
                              alt="ai_Icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>AI-Powered Matching</h4>
                            <p>
                              Effortlessly connect mentors and mentees based on
                              skills, goals, and preferences, ensuring the
                              perfect pairing every time.
                            </p>
                          </figcaption>
                        </div>
                      </Col>

                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/User-Centric-icon.svg"
                              alt="ai_Icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>User-Centric Experience</h4>
                            <p>
                              Provide a smooth journey from user registration to
                              submitting mentoring requests and easily
                              connecting with mentors, ensuring a seamless
                              process.
                            </p>
                          </figcaption>
                        </div>
                      </Col>

                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/Holistic_Icon.svg"
                              alt="Holistic_Icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>Holistic Mentoring Process</h4>
                            <p>
                              Empower mentoring success with user dashboards,
                              goal setting, feedback collection, meeting
                              scheduling, chat, and continued connections
                              post-engagement.
                            </p>
                          </figcaption>
                        </div>
                      </Col>

                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/Effortlessly-icon.svg"
                              alt="Effortlessly-icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>Effortlessly Configurable</h4>
                            <p>
                              Configure the platform to reflect your
                              organization's identity, content, and user and
                              admin workflows with ease.
                            </p>
                          </figcaption>
                        </div>
                      </Col>

                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/Scalability-icon.svg"
                              alt="Scalability-icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>Scalability & Flexibility</h4>
                            <p>
                              Seamlessly manage and scale tailored mentoring
                              programs, whether for small teams or global
                              networks, all within one platform.
                            </p>
                          </figcaption>
                        </div>
                      </Col>

                      <Col sm={6} lg={4}>
                        <div className="Our_Solution_Cols">
                          <figure className="icon_circle">
                            <img
                              src="./assets/images/Real-Time-icon.svg"
                              alt="Real-Time-icon"
                            />
                          </figure>
                          <figcaption>
                            <h4>Real-Time Data & Insights</h4>
                            <p>
                              Leverage intuitive dashboards to track engagement,
                              measure impact, and assess ROI in real time for
                              continuous improvement.
                            </p>
                          </figcaption>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="Choose_vLookUp_SaaS mb-4 mb-md-5">
                    <h3 className="block_Section">Why Choose vLookUp SaaS?</h3>
                    <div className="coreOfSolution_White_Wrapper">
                      <Row>
                        <Col lg={7} className="mb-4 md:mb-0">
                          <div className="Our_Solution_Outer">
                            <div className="Our_Solution_Cols">
                              <figure className="icon_circle">
                                <img
                                  src="./assets/images/Real-Time-icon.svg"
                                  alt="Real-Time-icon"
                                />
                              </figure>
                              <figcaption>
                                <h4>Enhance Community Engagement</h4>
                                <p>
                                  Cultivate deeper connections within your
                                  organization or alumni network, strengthening
                                  relationships and boosting retention.
                                </p>
                              </figcaption>
                            </div>

                            <div className="Our_Solution_Cols">
                              <figure className="icon_circle">
                                <img
                                  src="./assets/images/Real-Time-icon.svg"
                                  alt="Real-Time-icon"
                                />
                              </figure>
                              <figcaption>
                                <h4>Enhance Community Engagement</h4>
                                <p>
                                  Cultivate deeper connections within your
                                  organization or alumni network, strengthening
                                  relationships and boosting retention.
                                </p>
                              </figcaption>
                            </div>

                            <div className="Our_Solution_Cols">
                              <figure className="icon_circle">
                                <img
                                  src="./assets/images/Real-Time-icon.svg"
                                  alt="Real-Time-icon"
                                />
                              </figure>
                              <figcaption>
                                <h4>Enhance Community Engagement</h4>
                                <p>
                                  Cultivate deeper connections within your
                                  organization or alumni network, strengthening
                                  relationships and boosting retention.
                                </p>
                              </figcaption>
                            </div>
                          </div>
                        </Col>

                        <Col md={12} lg={5}>
                          <div className="chooseWithUs">
                            <img
                              src="./assets/images/with_Choose_US.png"
                              alt="with_Choose_US"
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="Choose_vLookUp_SaaS">
                    <div className="text-center V_Saas_Smart py-0">
                      <h3 className="block_Section mb-4">
                        Already Making an Impact
                      </h3>
                      <p>
                        Trusted by leading educational institutions like
                        the Singapore Institute of Management (SIM) and ESSEC
                        Business School, vLookUp is transforming mentorship into
                        a powerful growth and development tool.
                      </p>
                    </div>
                    <div className="Making_an_Impact">
                      <div className="V_Saas_Smart_bg_Img">
                        <img
                          src="./assets/images/ImpactSection.svg"
                          alt="ImpactSection"
                        />
                      </div>

                      <div className="impect_Web_List">
                        <ul>
                          <li>
                            <figure>
                              <img
                                src="./assets/images/ImpactWeb.png"
                                alt="ImpactWeb"
                              />
                            </figure>
                            <figcaption>
                              Singapore Institute of Management (SIM)
                            </figcaption>
                          </li>

                          <li>
                            <figure>
                              <img
                                src="./assets/images/ImpactWeb2.png"
                                alt="ImpactWeb"
                              />
                            </figure>
                            <figcaption>ESSEC Business School</figcaption>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="Policies_Fix">
                    <h6>Policies</h6>
                    <ul>
                      <li>
                        <img
                          src="./assets/images/Tech_Policy.svg"
                          alt="Tech_Policy"
                        />
                        Tech Policy
                      </li>
                      <li>
                        <img
                          src="./assets/images/Privacy-elements.svg"
                          alt="Privacy-elements"
                        />
                        Privacy Policy
                      </li>
                      <li>
                        <img
                          src="./assets/images/Executive-elements.svg"
                          alt="Executive-elements"
                        />
                        Executive Summary on Information Security
                      </li>
                    </ul>
                  </div>
                </div>
              </Tab>

              {/*  vLookUp Partnership */}

              <Tab eventKey="vLookUp_Partnership" title="vLookUp Partnership">
                <div className="V_Saas_Smart">
                  <h5>Curated Mentoring for Your Organization</h5>
                  <p>
                    At vLookUp, we collaborate with organizations and
                    institutions to create, scale, and automate impactful
                    mentoring programs. Whether you're empowering women
                    graduates and alumni, advancing leadership development, or
                    integrating mentorship into your diversity and inclusion
                    (D&I) initiatives, our tailored solutions help you build
                    meaningful, career-defining connections.
                  </p>
                </div>
                <div className="V_Partnership_Program">
                  <h4>
                    Bespoke & Curated Organization{" "}
                    <span>Mentoring Programs</span>
                  </h4>
                  <p>
                    Strengthen your D&I strategy by providing mentorship to
                    emerging talent. Encourage senior leaders to give back and
                    grow as mentors, or tap into the 420+ strong vLookUp mentor
                    community.
                  </p>

                  <div className="V_Partnership_Program_Partner">
                    <h5>Partner Stories</h5>
                    <p>
                      <b>Pernod Ricard India, MODEC Singapore,</b> and 
                      <b>Unioleo Indonesia</b> have partnered with vLookUp to
                      offer select women in their organizations the opportunity
                      to be mentored by leaders.
                    </p>
                    <div className="V_Partnership_list">
                      <ul>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/pernod.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/logomodec.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/uni.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <h4>
                    Community <span>Outreach</span>
                  </h4>
                  <p>
                    Design structured, goal-driven mentorship initiatives for
                    students or women’s groups across your organization.
                  </p>

                  <div className="V_Partnership_Program_Partner Community_Partner mb-0">
                    <h5>Partner Stories</h5>
                    <div className="V_Partnership_list">
                      <p>
                        <b>P&G’s Olay</b> worked with vLookUp for two years to
                        scale its STEM mentoring program in India, later
                        extending mentoring to NGOs like 
                        <b>Masoom, Mantra4Change, Swadha Foundation,</b> and
                        more.
                      </p>

                      <ul>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner1.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner2.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner3.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner4.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                      </ul>
                    </div>
                    <div className="V_Partnership_list">
                      <p>
                        <b>Republic Polytechnic</b> and 
                        <b>Nanyang Polytechnic</b> teamed up with vLookUp to
                        help students gain career-ready skills through
                        mentorship.
                      </p>

                      <ul>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner5.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/nyp.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                      </ul>
                    </div>
                    <div className="V_Partnership_list">
                      <p>
                        <b>Kearney’s IGNITE Group</b> leveraged our platform to
                        mentor women leaders in Indonesia.
                      </p>

                      <ul>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner6.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                      </ul>
                    </div>
                    <div className="V_Partnership_list">
                      <p>
                        <b>Dell Technologies</b> and the 
                        <b>
                          Singapore Computer Society’s Women in Tech Chapter 
                        </b>
                        have also partnered with vLookUp to mentor girls across
                        Singapore’s Polytechnics.
                      </p>

                      <ul>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/dell.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <img
                              src="./assets/images/Partner7.png"
                              alt="pernod.png"
                            />
                          </figure>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="vLookUp_Help_Corporate">
                  <div className="Help_Corporate_Content">
                    <h4>
                      We’ve Helped Global Corporations, Universities, and
                      Nonprofits Build{" "}
                      <span>
                        Transformative Mentoring Programs That Drive Real Change
                      </span>
                    </h4>
                    <p>Let’s work together to create something impactful.</p>
                    <Link to=""  class="btn">
                      Reach Out Today
                      <span className="ml-2 verticle-middle mt-1 mb-0"><img src="assets/images/whiteArrow.svg" /></span>
                    </Link>
                  </div>

                  <span className="Help_Corporate_Img">
                    <img src="./assets/images/helpImg.png" alt="help" />
                  </span>
                </div>

                <h2 className="about_Heading">
                  What Are We Passionate About and Focused On
                </h2>
                <div className="vLookUp_Help_Corporate vLookUp_AboutContent">
                  <span className="Help_Corporate_Img">
                    <img src="./assets/images/helpImg.png" alt="help" />
                  </span>
                  <div className="Vlookup_Content">
                    <div class="VlookUp_content_List">
                      <div class="icon_box">
                        <a
                          class="d-flex align-items-center align-items-center"
                          href="/dashboard"
                        >
                          <img alt="images" src="/assets/images/starIcon.png" />{" "}
                        </a>
                      </div>

                      <div class="descraption">
                        <a
                          class="d-flex pb-3 pt-0 align-items-center align-items-center"
                          href="/dashboard"
                        >
                          Making "giving and receiving support" seamless and
                          hassle-free for mentors and mentees.
                        </a>
                      </div>
                    </div>
                    <div class="VlookUp_content_List">
                      <div class="icon_box">
                        <a
                          class="d-flex align-items-center align-items-center"
                          href="/dashboard"
                        >
                          <img alt="images" src="/assets/images/starIcon.png" />{" "}
                        </a>
                      </div>

                      <div class="descraption">
                        <a
                          class="d-flex pb-3 pt-0 align-items-center align-items-center"
                          href="/dashboard"
                        >
                          Driving deeper community engagement with
                          a user-centric design and tool.
                        </a>
                      </div>
                    </div>
                    <div class="VlookUp_content_List">
                      <div class="icon_box">
                        <a
                          class="d-flex align-items-center align-items-center"
                          href="/dashboard"
                        >
                          <img alt="images" src="/assets/images/starIcon.png" />{" "}
                        </a>
                      </div>

                      <div class="descraption">
                        <a
                          class="d-flex pb-3 pt-0 align-items-center align-items-center"
                          href="/dashboard"
                        >
                          Supporting organizations with impactful
                          and data-driven mentoring programs.
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="vLookUp_Help_Corporate join_LookUp">
                  <div className="Help_Corporate_Content">
                    <h4>
                    Join the vLookUp Movement
                    </h4>
                    <p>Whether you need a configurable mentoring platform or a curated partnership program for your organization, we’re here to help you create impactful connections.</p>
                    <span>Contact Us to discover how vLookUp can elevate your mentoring initiatives</span>
                    <Link to="#" class="btn">
                    Contact Us
                    <span className="ml-2 verticle-middle mt-1 mb-0"><img src="assets/images/whiteArrow.svg" /></span>
                    </Link>
                  </div>

                  <span className="Help_Corporate_Img">
                    <img src="./assets/images/helpImg.png" alt="help" />
                  </span>
                </div>
                <div className="Policies_Fix">
                    <h6>Policies</h6>
                    <ul>
                      <li>
                        <img
                          src="./assets/images/Tech_Policy.svg"
                          alt="Tech_Policy"
                        />
                        Tech Policy
                      </li>
                      <li>
                        <img
                          src="./assets/images/Privacy-elements.svg"
                          alt="Privacy-elements"
                        />
                        Privacy Policy
                      </li>
                      <li>
                        <img
                          src="./assets/images/Executive-elements.svg"
                          alt="Executive-elements"
                        />
                        Executive Summary on Information Security
                      </li>
                    </ul>
                  </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </section>

      <section className="brand_sec partner_sec">
        <Container>
          <div className="title text-center space-bottom">
            Partnering Organisations and Institutions
          </div>
          <Slider {...Brand}>
            {brand.map((item, key) => (
              <div key={key}>
                <div className="brand">
                  <img src={item.image} alt={`Brand ${key}`} />
                </div>
              </div>
            ))}
          </Slider>
        </Container>
      </section>

      <section className="parter-slider py-4">
        <Container>
          <h2 className="title text-center space-bottom position-relative">
            Client Stories
          </h2>
          <Slider {...patner_slider}>
            {/* new */}

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="./assets/images/testimonial/olay.png"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <strong>Event: Olay STEM Mentoring Programme 2.0</strong>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="./assets/images/testimonial/republic.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <strong>Event: Republic Polytechnic x vLookUp</strong>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="./assets/images/testimonial/dell.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <strong>
                      Event: Dell, Women in Action, Girls in Tech Mentoring
                      Programme
                    </strong>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="./assets/images/testimonial/gitpic.png"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <strong>
                      Event: GIT x NCS x vLookUp Hackathon Empowering{" "}
                    </strong>
                  </h3>
                </div>
              </div>
            </div>
          </Slider>
        </Container>
      </section>

      {/* <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="footerleft text-md-left ">
                <Link className="logo" to="/" title="Home">
                  <img
                    src="./assets/images/logo.png"
                    alt="professional consultants for women"
                    className="img-fluid"
                  />
                </Link>
                <p>
                  We create impactful connections for rising women. We offer
                  one-on-one connections and domain-specific, career-advancing
                  conversations between aspiring women leaders and experienced
                  industry leaders. We achieve this through a network of
                  passionate people developers and diversity champions, an AI
                  platform that creates relevant, quality matching, and
                  domain-based communities.
                </p>
              </div>
            </div>
            <div className="col-md-4 offset-md-1 pt-4 pt-md-0">
              <div className="footertop quick_box">
                <h3>Quick Links</h3>
                <ul className="quicklinks">
                  <li>
                    <Link className="logo" to="/" title="Home">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="logo"
                      to="/page/privacy-policy"
                      title="Privacy Policy"
                    >
                      Privacy policy
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/aboutus" title="About">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="logo"
                      to="/page/terms-and-conditions"
                      title="Terms and conditions"
                    >
                      Terms and conditions
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/login" title="Login">
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/faq" title="FAQ">
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/register" title="Sign Up">
                      Sign Up
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/contact-us" title="Contact Us">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 pt-4 pt-md-0">
              <div className="footertop ml-md-auto">
                <h3>Connect With Us</h3>
                <ul className="sociallink">
                  <li>
                    <a
                      className="App-link"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" title="Facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className="App-link"
                      href="/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >                      <img
                        className="withouthoverShow"
                        src="assets/images/twiter_x.svg"
                        width={23}
                        height={23}
                        title="Twitter"
                      />
                      <img
                        className="withhoverShow"
                        src="assets/images/twiter_xhover.svg"
                        width={23}
                        height={23}
                        title="Twitter"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      className="App-link"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin" title="Linkedin"></i>
                    </a>
                  </li>

                  <li>
                    <a
                      className="App-link"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" title="Youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className="App-link"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" title="Instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className="App-link"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-spotify" title="Spotify"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footertop ml-md-auto" style={{ margin: `9px` }}>
                <p>
                  {" "}
                  <i className="far fa-envelope"></i> &nbsp;{" "}
                  <a className="App-link" href="">
                    support@vlookup.ai
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <p> © Copyright 2024 - vlookup.ai. All Rights Reserved.</p>
          </div>
        </div>
      </footer> */}
    </div>
  );
};

export default index;
